/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import React, { useEffect, useState } from 'react';
import { Navigate } from "react-router-dom";
import Cookies from 'js-cookie';
import { accessMangerBasePath, docSearchBasePath } from '../constants/env-url';
import { ROLES } from '../constants/commonConstants';
import { decryptUserData } from '../utils';

interface GuardedRouteProps {
  children: React.ReactChild,
  roleRequired?: any,
  user?: any,
}

export interface DecryptedUser {
  id: number;
  roles: string[];
  isAdmin: boolean;
};

export const defaultDecryptedUser: DecryptedUser = {
  id: 0,
  roles: [],
  isAdmin: false,
};

const useAuth = (user: any) => {
  
  if (user?.roles && user?.roles.length && user?.roles.includes(ROLES.SUPER_ADMIN)) {
    return {
      auth: true,
      role: ROLES.SUPER_ADMIN,
    }
  }
  else if (user?.roles && user?.roles.length && user?.roles.includes(ROLES.USER_MGMT_ADMIN)) {
    return {
      auth: true,
      role: ROLES.USER_MGMT_ADMIN,
    }
  }
  else {
    return {
      auth: false,
      role: null,
    }
  }
}

const GuardedRoute: React.FC<GuardedRouteProps> = (props: any) => {

  const { children, user } = props;
  const { auth, role } = useAuth(user)
  const [userInfo, setUserInfo] = useState(defaultDecryptedUser);

  useEffect(() => {
    decryptUserData()?.then((decryptUserData) => {
      setUserInfo(decryptUserData);
    })
  }, []);

  if (Cookies.get('auth') == undefined || Cookies.get('auth') == 'false') {
    let loginUrl = `${accessMangerBasePath}/login`;
    const param = new URLSearchParams(window.location.search);
    const redirectUrl = param.get('redirectUrl');
    if (redirectUrl) {
      loginUrl = `${loginUrl}?redirectUrl=${redirectUrl}`
    }
    window.location.href = loginUrl;
    return;
  }

  if (props.roleRequired && role) {
    return props.roleRequired.includes(role) ? (
      children
    ) : (
      <Navigate to="/applications" />
    )
  }

  if (userInfo?.roles && userInfo?.roles.length == 1 && (userInfo?.roles[0] === ROLES.DOC_SEARCH_DEMO_USER || userInfo?.roles[0] === ROLES.DOC_SEARCH_USER || userInfo?.roles[0] === ROLES.GUEST)) {
    window.location.href = `${docSearchBasePath}`;
  } else {
    return children;
  }
};

export default GuardedRoute;